










import Vue from 'vue';
import isGranted from '@/auth/isGranted';
import { openModal } from 'mycorems-app-shared';
import { DetailedEmailCampaign } from '@/types';
import GenerateReportConfirmationModal from './GenerateReportConfirmationModal.vue';

export default Vue.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
    campaign: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    sentAt: {
      type: String,
      required: true,
    },
  },
  methods: {
    open(): void {
      openModal(GenerateReportConfirmationModal, {
        emailCampaignId: this.emailCampaignId,
        campaign: this.campaign,
        subject: this.subject,
        sentAt: this.sentAt,
      }).onOk((emailCampaign: DetailedEmailCampaign) => {
        this.$emit('generated', emailCampaign);
      });
    },
    isGranted,
  },
});
